var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "blob",
    xmlnsXlink: "blob",
    viewBox: "6475 1125 475 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ablob{clip-path:url(#bblob);}.bblob{fill:#acacd4;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "bblob"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6475,
    y: 1125,
    width: 475,
    height: 250
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ablob",
    className: "ablob"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bblob",
    d: "M11030.129,1090.174s-100.134,8.406-88.954-14.18.983-130.255,31.813-140.871,40.539-77.469,145.225-45.171,105.444,54.164,182.915,12.719,112.28,134.879,112.28,134.879,9.713,80.4-23.375,68.434-146.922,42.235-167.926,18.859-88.762-80.631-125.691-64.821S11030.129,1090.174,11030.129,1090.174Z",
    transform: "translate(-4465 244)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.6fcd84aa881703e6063d747b7a535e97.svg";
export { ForwardRef as ReactComponent };